import { Box, Grid } from '@mui/material';

import { ProductItem } from './product-item';
import { PaginationControl } from 'src/components/pagination-buttons/pagination-control.component';
import { IPublicProductItem, IPopularProductItem } from 'src/types';

interface IProps {
  products: IPublicProductItem[] | IPopularProductItem[];
  withPagination?: boolean;
}

export const ProductListComponent = ({ products, withPagination }: IProps) => {
  return (
    <Box id="index__components-home-products-list__box__l14"
    sx={{
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px'
    }}>
      
      {withPagination && products?.length > 0 &&
      <PaginationControl containerStyles={{ justifyContent: 'center' }} />
      }
      <Grid id="index__components-home-products-list__grid__l27" container spacing={3} sx={{ width: '100%' }}>
        {products.map((product) =>
        <Grid id="index__components-home-products-list__grid__l29" sx={{ width: '100%' }} item xs={6} sm={4} md={3} key={product.simple_id}>
            <ProductItem product={product} />
          </Grid>
        )}
      </Grid>
      {withPagination && products?.length > 0 &&
      <PaginationControl containerStyles={{ justifyContent: 'center' }} />
      }
    </Box>);

};